"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var getCurrentItem_1 = __importDefault(require("./getCurrentItem"));
/**
 * Get depth of current block in a document list
 */


var getItemDepth = function getItemDepth(opts) {
  return function (value, block) {
    var document = value.document,
        startBlock = value.startBlock;
    block = block || startBlock;
    var currentItem = getCurrentItem_1.default(opts)(value, block);

    if (!currentItem) {
      return 0;
    }

    var list = document.getParent(currentItem.key);
    return 1 + getItemDepth(opts)(value, list);
  };
};

exports.default = getItemDepth;